import { COMPANY_NAVBAR_MOBILE_IS_OPEN_ATOM } from "components/company/v3/menu/atoms";
import { useAtom, useAtomValue, useSetAtom } from "jotai";

export const useCompanyNavbarMobileIsOpenValue = () => useAtomValue(COMPANY_NAVBAR_MOBILE_IS_OPEN_ATOM);
export const useCompanyNavbarMobileIsOpen = () => useAtom(COMPANY_NAVBAR_MOBILE_IS_OPEN_ATOM);
export const useSetCompanyNavbarMobileIsOpen = () => useSetAtom(COMPANY_NAVBAR_MOBILE_IS_OPEN_ATOM);
